import { Component, OnInit } from '@angular/core';
import { PaquetesService } from 'src/app/services/paquetes.service';
import { environment } from '../../../environments/environment';
import { Ng2IzitoastService } from 'ng2-izitoast';

@Component({
  selector: 'app-contenido',
  templateUrl: './contenido.component.html',
  styleUrls: ['./contenido.component.scss']
})
export class ContenidoComponent implements OnInit {
  environment = environment.BASE_URL
  respuestaUpdate:any;
  respuestaGet:any;
  contenido:any;
  formularioEdit:any;

  constructor(private _paquetes:PaquetesService, private iziToast:Ng2IzitoastService) { }

  ngOnInit(): void {
    this.getContenido();
    this.formularioEdit = {
      'nombre':'',
      imagen: '',
      'video':'',
      'video_registro':'',
    }

    this.contenido = {
      'video':'',
      'video_registro':'',
    }
  }
  


  getContenido(){
    this._paquetes.getContenido().subscribe(
      data => {
        this.respuestaGet = data;
        if(this.respuestaGet.success){
          this.contenido = this.respuestaGet.content[0];
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  videoChange(files: FileList){
    this.formularioEdit.video = files.item(0);
    console.log('File Change', this.formularioEdit.video);
  }

  videoChangeRegistro(files: FileList){
    this.formularioEdit.video_registro = files.item(0);
    console.log('File Change', this.formularioEdit.video_registro);
  }

  
  actualizarVideo(){
    const formData = new FormData();
    if (this.formularioEdit.video){ 
      formData.append('video', this.formularioEdit.video);
      formData.append('contenido', this.contenido.id);
    }

    this._paquetes.actualizarVideo(formData).subscribe(
      data => {
        this.respuestaUpdate = data;
        if(this.respuestaUpdate.success){
          this.iziToast.show(
            {
                title: 'Se ha actualizado correctamente.',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
          this.getContenido();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }


  actualizarVideoRegistro(){
    const formData = new FormData();
    if (this.formularioEdit.video_registro){ 
      formData.append('video_registro', this.formularioEdit.video_registro);
      formData.append('contenido', this.contenido.id);
    }

    this._paquetes.actualizarVideoRegistro(formData).subscribe(
      data => {
        this.respuestaUpdate = data;
        if(this.respuestaUpdate.success){
          this.iziToast.show(
            {
                title: 'Se ha actualizado correctamente.',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
          this.getContenido();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

 
}

